import { Slider } from "@mui/material";
import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import styles from "./StepFour.module.css";
import Header from "../../Header/Header";
import { useNavigate } from "react-router-dom";
import config from "../../../config";
import { showErrorToast } from "../../utils";

export default function StepFourInsurance() {
    const [selectedOptions, setSelectedOptions] = useState({ hasFiledClaim: "", requiresFloodInsurance: "" });
    const navigate = useNavigate();
    const storageInfo = JSON.parse(sessionStorage.getItem("insuranceInfo"));
    useEffect(() => {
        if (storageInfo?.additionalDetails) {
            const info = storageInfo.additionalDetails;
            console.log(storageInfo);
            setSelectedOptions(info);
        }
    }, []);
    const handleSubmit = async (e) => {
        e.preventDefault();
        // Validate form inputs
        if (!validateForm()) return;

        // const authUserToken = localStorage.getItem("authUser");
        // const authUser = authUserToken ? authUserToken.replace(/^"|"$/g, "") : "";

        sessionStorage.setItem(
            "insuranceInfo",
            JSON.stringify({
                ...storageInfo,
                additionalDetails: { hasFiledClaim: selectedOptions?.hasFiledClaim, requiresFloodInsurance: selectedOptions?.requiresFloodInsurance },
            })
        );

        navigate("/services/insurance-quote/step-5");

        try {
            // const response = await fetch(`${config.get("API_URL")}/personal_info`, {
            //     method: "POST",
            //     headers: {
            //         "Content-Type": "application/json",
            //         Authorization: `Bearer ${authUser}`,
            //     },
            //     body: JSON.stringify({
            //         first_name: firstName,
            //         last_name: lastName,
            //         email: email,
            //         phone_number: phoneNumber,
            //         address: address,
            //         unit_number: unitNumber,
            //     }),
            // });
            // const responseData = await response.json(); // Parse the response body
            // if (response.ok) {
            //     console.log("Response:", responseData); // Log the response
            //     showSuccessToast("Form submitted successfully!");
            //     navigate("/services/insurance-quote/step-2");
            // } else {
            //     console.log("Error Response:", responseData); // Log the error re sponse
            //     showErrorToast(`Failed to submit: ${responseData.message || "Please try again."}`);
            // }
        } catch (error) {
            console.error("Error submitting the form:", error);
            showErrorToast("An error occurred. Please try again.");
        }
    };

    useEffect(() => {
        document.title = `Insurance | ${config.get("COMPANY_NAME")}`;
    }, []);

    const validateForm = () => {
        if (!selectedOptions.hasFiledClaim || !selectedOptions.requiresFloodInsurance) {
            // showErrorToast("Please fill in all fields.");
            showErrorToast("Please fill in all fields.");
            return false;
        }
        // // Email validation
        // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        // if (!emailRegex.test(email)) {
        //     showErrorToast("Please enter a valid email address.");
        //     return false;
        // }

        return true; // If everything is valid
    };
    const questions = [
        {
            name: "hasFiledClaim",
            title: "Have you filed an insurance claim in the last 5 years?",
            options: ["Yes", "No"],
        },
        {
            name: "requiresFloodInsurance",
            title: "Do you require flood insurance?",
            options: ["Yes", "No"],
        },
    ];
    const handleOptionChange = (questionIndex, optionIndex, name) => {
        setSelectedOptions((prevSelectedOptions) => ({
            ...prevSelectedOptions,
            [name]: optionIndex,
        }));
    };

    return (
        <div>
            <div className={`${styles.container} tw-bg-background_color`}>
                <main className={`${styles.mainContent} tw-overflow-y-auto`}>
                    <Header title="Insurance Quote" />
                    <section className={styles.formSection}>
                        {/* <ProgressBar currentStep={1} totalSteps={7} /> */}
                        <div className={styles.formContainer}>
                            <h1 className={styles.formTitle}>Fine-Tune Your Quote</h1>
                            {/* <p className="tw-font-semibold">A few more questions to ensure your quote is as accurate as possible.</p> */}
                            <p className={`${styles.formDescription} tw-text-justify`}>
                                Your insurance history and specific property risks can affect your coverage options and rates. Providing this
                                information helps insurers offer you the most appropriate and competitively priced policies
                            </p>
                            <form className={styles.generalForm} onSubmit={handleSubmit}>
                                <div className={`${styles.formRow} max-sm:tw-flex-wrap`}>
                                    {questions.map((question, index) => (
                                        <section key={index} className={"tw-flex tw-flex-wrap tw-w-full"}>
                                            <h2 className={styles.formTitle}>
                                                <div className={styles.formTitleText}>{question.title}</div>
                                            </h2>
                                            <div className={styles.optionsContainer}>
                                                <div className={`${styles.optionsList} tw-flex tw-flex-row  gap-2`}>
                                                    {question.options.map((option, optionIndex) => (
                                                        <React.Fragment key={optionIndex + 1}>
                                                            <input
                                                                type="radio"
                                                                id={`question${index}-option${optionIndex + 1}`}
                                                                name={question.name}
                                                                value={option}
                                                                className={`${styles["visually-hidden"]}`}
                                                                checked={selectedOptions[question.name] === optionIndex + 1}
                                                                onChange={(e) => handleOptionChange(index, option, e.target.name)}
                                                            />
                                                            <label
                                                                htmlFor={`question${index}-option${optionIndex + 1}`}
                                                                className={`${styles.optionItem} max-sm:tw-w-full tw-border-1 ${selectedOptions[question.name].toLowerCase() === option.toLowerCase() ? "tw-bg-primary hover:tw-bg-primary_hover tw-text-white" : ""}`}
                                                            >
                                                                {option}
                                                            </label>
                                                        </React.Fragment>
                                                    ))}
                                                </div>
                                            </div>
                                        </section>
                                    ))}
                                </div>
                                {/* <p className="tw-text-secondary tw-italic">
                                    Being honest about your claims history and flood risk ensures you get the most accurate quotes and appropriate
                                    coverage
                                </p> */}
                                <div className="tw-flex tw-justify-center">
                                    <button
                                        type="submit"
                                        className={`${styles.submitButton} max-sm:tw-w-full tw-bg-primary hover:tw-bg-primary_hover tw-w-fit`}
                                    >
                                        Review Your Information{" "}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </section>
                </main>
            </div>
        </div>
    );
}
